import { render } from "./FormPajakSeriEdit.vue?vue&type=template&id=0581b502"
import script from "./FormPajakSeriEdit.vue?vue&type=script&lang=js"
export * from "./FormPajakSeriEdit.vue?vue&type=script&lang=js"

import "./FormPajakSeriEdit.vue?vue&type=style&index=0&id=0581b502&lang=css"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__